import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { config } from '@this/shared/dist/tools/config.js';
import { reactPlugin } from './global.js';
const AppInsightsErrorBoundaryAny = AppInsightsErrorBoundary;
function ErrorMessage() {
    // TODO: styling
    return (_jsxs("div", { children: ["Leider ist ein unvorhergesehener Fehler aufgetreten. Bitte versuchen Sie es sp\u00E4ter noch einmal. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an das", ' ', _jsx("a", { href: `mailto:${config.support.email}`, children: "Support-Team" })] }));
}
export function InsightsBoundary({ children }) {
    return (_jsx(AppInsightsErrorBoundaryAny, { onError: () => _jsx(ErrorMessage, {}), appInsights: reactPlugin, children: _jsx(AppInsightsContext.Provider, { value: reactPlugin, children: children }) }));
}
